/** Verified field labels for a background browser fill. Entered text stays in the page. */
export function WorkToastBrowserFillFields({ names }: { names: string[] }) {
  if (names.length === 0) return null;
  return (
    <ul className="flex flex-col gap-1 text-appkit-small text-primary" data-testid="work-toast-browser-fill-fields">
      {names.map((name, index) => (
        <li key={`${index}:${name}`} className="min-w-0 break-words" data-testid={`work-toast-browser-fill-field-${index}`}>
          {name}
        </li>
      ))}
    </ul>
  );
}
